// src/components/Navbar.tsx
import { useState } from "react";
import { useWallet } from "../context/WalletContext";
import { NAV_LINKS } from "../data/content.js";

export default function Navbar() {
  const { connected, address, balanceMEE, isDemo, connect, disconnect, openWalletModal } = useWallet();
  const [menuOpen, setMenuOpen] = useState(false);

  const shortAddr = address ? `${address.slice(0, 8)}…${address.slice(-4)}` : "";
  const bal = connected ? parseFloat(balanceMEE).toLocaleString("th-TH", { maximumFractionDigits: 2 }) : "";

  return (
    <nav style={{
      position: "sticky", top: 0, zIndex: 100,
      display: "flex", alignItems: "center", padding: "0 32px", height: 60,
      background: "rgba(7,7,15,.92)", borderBottom: "1px solid rgba(124,58,237,.12)",
      backdropFilter: "blur(20px)",
    }}>
      {/* Logo */}
      <a href="#" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none", marginRight: 48 }}>
        <div style={{
          width: 38, height: 38, background: "linear-gradient(135deg,#7c3aed,#4f46e5)",
          borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center",
          fontFamily: "var(--display)", fontSize: 20, fontWeight: 900, color: "#fff",
          boxShadow: "0 0 20px rgba(124,58,237,.4)",
        }}>M</div>
        <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
          <span style={{ fontFamily: "var(--display)", fontSize: 17, fontWeight: 700, color: "#fff", letterSpacing: ".08em" }}>MEECHAIN</span>
          <span style={{ fontSize: 9, letterSpacing: ".22em", color: "var(--muted)", textTransform: "uppercase" }}>NETWORK</span>
        </div>
      </a>

      {/* Nav links */}
      <div style={{ display: "flex", gap: 4, flex: 1 }} className="nav-links-desktop">
        {NAV_LINKS.map(link => (
          <a key={link.label} href={link.href}
            target={link.external ? "_blank" : undefined}
            rel={link.external ? "noreferrer" : undefined}
            style={{
              padding: "6px 16px", fontSize: 13, fontWeight: 500,
              color: link.active ? "#fff" : "var(--muted)",
              textDecoration: "none", borderRadius: 6,
              borderBottom: link.active ? "2px solid var(--purple2)" : "none",
              transition: "color .15s",
            }}
          >{link.label}</a>
        ))}
      </div>

      {/* Right */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginLeft: "auto" }}>
        <div style={{
          display: "flex", alignItems: "center", gap: 6, padding: "6px 12px",
          background: "var(--bg3)", border: "1px solid rgba(124,58,237,.25)", borderRadius: 8,
          fontSize: 12, fontFamily: "var(--mono)", color: "var(--text)",
        }}>
          <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#34d399", boxShadow: "0 0 8px #10b981" }} />
          Chain 13390
        </div>

        {connected ? (
          <button onClick={disconnect} style={{
            display: "flex", alignItems: "center", gap: 8, padding: "8px 18px",
            fontSize: 13, fontWeight: 700, background: "rgba(16,185,129,.15)",
            border: "1.5px solid rgba(16,185,129,.4)", color: "#34d399",
            borderRadius: 8, cursor: "pointer", fontFamily: "var(--sans)",
          }}>
            <span>{isDemo ? "🤖" : "🦊"}</span>
            {shortAddr} ({bal} MEE)
          </button>
        ) : (
          <button onClick={openWalletModal} style={{
            display: "flex", alignItems: "center", gap: 8, padding: "8px 18px",
            fontSize: 13, fontWeight: 700, background: "transparent",
            border: "1.5px solid var(--purple2)", color: "var(--purple3)",
            borderRadius: 8, cursor: "pointer", fontFamily: "var(--sans)",
            transition: "all .18s",
          }}>
            ⬡ CONNECT WALLET
          </button>
        )}
      </div>
    </nav>
  );
}
